module.exports = __webpack_public_path__ + "static/media/low_loss_light.a7783390.svg";